import { useSelector } from 'react-redux';
export const useTypeSelector = useSelector;
